export const FILTER_VALUES = {
    ALL: "all"
};
